let onlyInDev = false;

if (process.env.REACT_APP_SHOW_DEV === 'true' ) {
    onlyInDev = true
}

export const showOnlyInDev = onlyInDev;